import { useParams, useSearchParams } from 'react-router-dom';

import { ErrorMessage } from '@Components';
import FieldServiceDetailContainer from './fieldServiceDetail.container';

const FieldServiceWrapper = () => {
  const { fieldServiceId } = useParams();
  const [searchParams] = useSearchParams();
  const retailer = searchParams.get('retailer') ?? undefined;

  if (!fieldServiceId) {
    return <ErrorMessage internalMessage="Unable to get field service" />;
  }
  return (
    <FieldServiceDetailContainer
      key={`${fieldServiceId}-${retailer ?? ''}`}
      fieldServiceId={fieldServiceId}
      retailer={retailer}
    />
  );
};

export default FieldServiceWrapper;
